import { ISecto } from 'pages/Sectorisation/types';
import { cdmApi } from '.';

const PREFIX = '/secto';

const sectoApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getSectoLists: builder.query<{ lists: ISecto[] }, { idTool: number; retailerId: number }>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: ['Secto'],
        }),
        getActionTypeLists: builder.query<{ action_types: string[] }, { idTool: number }>({
            query: (params) => ({ url: `${PREFIX}/action_type`, method: 'get', params }),
        }),
        getSectorsLists: builder.query<{ sectors: any }, { idTool: number }>({
            query: (params) => ({ url: `${PREFIX}/sectors`, method: 'get', params }),
        }),
        updateSecto: builder.mutation<{ code: number; message: string; users: any }, any>({
            query: (data) => ({ url: `${PREFIX}/update`, method: 'post', data }),
            invalidatesTags: ['Secto'],
        }),
        uploadSectoExcel: builder.mutation<{ code: number }, FormData>({
            query: (data) => ({ url: `${PREFIX}/excel/upload`, method: 'post', data }),
            invalidatesTags: ['Secto'],
        }),
        exportSectoExcel: builder.mutation<any, any>({
            query: (data) => ({
                url: `${PREFIX}/excel/export`,
                method: 'post',
                responseType: 'arraybuffer',
                data,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetSectoListsQuery,
    useLazyGetSectoListsQuery,
    useGetActionTypeListsQuery,
    useUpdateSectoMutation,
    useGetSectorsListsQuery,
    useExportSectoExcelMutation,
    useLazyGetSectorsListsQuery,
    useUploadSectoExcelMutation,
} = sectoApi;
